var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 818.3 1301.6",
    style: {
      enableBackground: "new 0 0 818.3 1301.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000053531089020249661060000018098343373066678459_);fill:#F7B28C;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 818.3,
    height: 1301.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138568693664055577440000000910854225335102111_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000138568693664055577440000000910854225335102111_)",
      fill: "#F7B28C"
    },
    d: "M511.4,210 c-17.5-26.5-48-39.8-91.4-39.8c-33.8,0-61.3,8.1-82.4,24.4c-21.1,16.3-37.4,38.9-48.9,67.9c-11.5,29-19,63.4-22.6,103.2 c-3.6,39.8-5.4,83.3-5.4,130.3v63.4h3.6c21.7-33.8,52.8-60.6,93.2-80.6C398,458.9,447.1,449,505.1,449c56.7,0,105,10,144.8,29.9 c39.8,19.9,72.1,47.7,96.9,83.3c24.7,35.6,42.8,77.8,54.3,126.7c11.5,48.9,17.2,102.3,17.2,160.2c0,148.4-32.9,261-98.7,337.6 c-65.8,76.7-171.1,115-315.9,115c-89.3,0-160.5-15.7-213.6-47.1c-53.1-31.4-93.9-74.5-122.2-129.4c-28.4-54.9-46.8-118.6-55.2-191 C4.2,861.7,0,786.3,0,707.8c0-90.5,2.7-178.3,8.1-263.4c5.4-85.1,21.7-160.5,48.9-226.3c27.2-65.8,69.7-118.6,127.6-158.4 C242.6,19.9,324.6,0,430.9,0c45.9,0,90.2,5.4,133.1,16.3c42.8,10.9,80.6,29,113.1,54.3c32.6,25.3,58.8,58.8,78.7,100.5 c19.9,41.6,30.5,93.2,31.7,154.8H537.7C537.7,275.2,528.9,236.6,511.4,210 M278.8,984.8c3.6,31.4,10.6,58.2,20.8,80.6 c10.2,22.3,24.7,39.8,43.4,52.5c18.7,12.7,43.1,19,73.3,19c31.4,0,56.4-6.3,75.1-19c18.7-12.7,32.9-30.5,42.5-53.4 c9.6-22.9,16-49.8,19-80.6c3-30.8,4.5-64.3,4.5-100.5c0-86.9-10.9-149-32.6-186.5c-21.7-37.4-57.9-56.1-108.6-56.1 c-51.9,0-88.7,18.7-110.4,56.1c-21.7,37.4-32.6,99.6-32.6,186.5C273.4,919.6,275.2,953.4,278.8,984.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo06);
export default __webpack_public_path__ + "static/media/no-06.99b8323973e246acc39d215e39250f31.svg";
export { ForwardRef as ReactComponent };